/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $mainMenu = $('.main-menu');
        $topMenu = $('.menu-top');
        $searchBtn = $('.toggle-search-btn');
        $ajaxFilters = $('.ajax-filters a');
        $downloadsCarousel = $('#downloadsCarousel');
        $blockNavigation = $('.block-navigation');

        //$topMenu.on('mouseenter',function(){
        //  $mainMenu.addClass('active');
        //});

        /* Activate menu on scroll & display backtop button */
        $(window).on('scroll',function(e){
          if( $(window).width() >= 1020 ){
            if( $(window).scrollTop() > 2500 ){
              $('.backtop').css('opacity','1');
            }else{
              $('.backtop').css('opacity','0');
            }
          }else{
            if( $(window).scrollTop() > 2000 ){
              $('.backtop').css('opacity','1');
            }else{
              $('.backtop').css('opacity','0');
            }
          }
        });

        /* Search box */
        $searchBtn.on('click', function(e){
          e.preventDefault();
          $('.desktop-menu .search-field').focus();
          $searchBtn.parents('.searchbox').toggleClass('open').promise().done(function(e){
            if( $(e).hasClass('open') ){
              $searchBtn.parents('.searchbox').width($(window).width() - $('.nav-primary li.icon-colibri').offset().left );
              $searchBtn.parents('.searchbox form').css('visibility','visible');
            }else{
              $searchBtn.parents('.searchbox form').delay(400).css('visibility','hidden');
              $searchBtn.parents('.searchbox').delay(400).css('width','0');
            }
          });
        });

        /* Scroll to */
        $('.scrollto').on('click', function(e){
          e.preventDefault();
          var id = $(this).attr('href');
          if( $(this).attr('data-scrollback') ){
            $('html, body').animate({scrollTop: $(id).offset().top-$(this).attr('data-scrollback')}, 500);
          }else{
            $('html, body').animate({scrollTop: $(id).offset().top}, 500);
          }
        });

        /* Submenu tweak */
        $('.main-menu .sub-menu').each(function(){
          $(this).find('li').wrapAll( "<div class='sub-menu-inner'></div>" );
        });

        if( $(window).width() <= 992 ) {
          //Force sub-menu to close when menu is open
          $('.btn-menu-mobile').on('click', function(){
            if( $(this).attr('aria-expanded') == 'false' ){
              $('.nav-primary .sub-menu').removeClass('active');
            }
          });

          $('.nav-mobile ul.nav > li.menu-item-has-children').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('active-link');
            if( $(this).hasClass('active-link') ){
              $('.nav-primary .sub-menu').removeClass('active');
              $(this).find('.sub-menu').toggleClass('active');
            }else{
              $(this).find('.sub-menu').toggleClass('active');
            }
          });
          $('.sub-menu li').on('click', function(e){
            e.stopPropagation();
          });
        }

        $('.backtop').on('click', function(e){
          e.preventDefault();
          $('html, body').animate({scrollTop: 0}, 500);
        });

        /* Carousels for downloads and news list */
        if( $downloadsCarousel.length ){
          $downloadsCarousel.carousel({
            interval: false,
            ride: false,
            keyboard: true
          });

          $downloadsCarousel.on('slide.bs.carousel', function ( event ) {
            var slideTo = parseInt( $(event.relatedTarget).index() + 1);
            $('.carousel-navigation .carousel-indicators li').removeClass('active');
            $('.carousel-navigation .carousel-indicators li:nth-child('+slideTo+')').addClass('active');
          });
        }

        /* Mobile friendly carousels */
        $('.carousel').bcSwipe({ threshold: 50 });

        /* Scrolling animation triggering */
        /* Mise en place effet au scroll */
        $.fn.visible = function(partial) {
          var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

          return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

        $(".module").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.removeClass("module");
          }
        });

        $(".module-start").each(function(i, el) {
          var el = $(el);
          if (el.visible(true)) {
            el.addClass("come-in");
          }
        });

        $(window).scroll(function(event) {

          $(".module").each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
              el.addClass("come-in");
            }
          });

          $(".module-slow").each(function(i, el) {
            var el = $(el);
            if (el.visible(true)) {
              el.addClass("fadein");
            }
          });

        });

        if( $blockNavigation.length ){
          $blockNavigation.find('.carousel-controls').width($blockNavigation.find('.carousel-indicators').outerWidth(true));
        }



        /* Ajax searchbus form */
        if( $('.searchbus-form').length > 0 ){
          $('.searchbus-form select#lignes').on('change', function(event) {
            event.preventDefault();
            var $lazy_btn = $(this);
            var ligne_id = $(this).find('option:selected').val();
            var arret_id = $('select[name="arrets"] option:selected').val();

            if( ligne_id.length === 0 ){
              ligne_id = null;
            }


            if( $(this).val() ){
              $(this).parent().next().find('.ajax-loader').show();
              $(this).parent().next().find('select').addClass('loading');


              $.ajax({
                  url: ajaxurl,
                  type: 'POST',
                  dataType: 'JSON',
                  data: { ligne_id: ligne_id, action: 'search_arrets', arret: arret_id }
                })
                .done(function(response) {
                  $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
                  if( response && response.html != "" ){
                    $('select#arrets').empty().append(response.html);
                  }
                })
                .fail(function() {
                  $('.searchbus-form select#lignes').parent().next().find('.ajax-loader').hide();
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
                })
                .always(function() {
                  $('.searchbus-form select#lignes').parent().next().find('select').removeClass('loading');
                });
            }

          });
        }


        $ajaxFilters.on('click', function(e){
          e.preventDefault();
          var post_type = $(this).data('post-type');
          var taxonomy = $(this).data('tax');
          var terms_id = [];

          $('.ajax-filters a').removeClass('active');

          if( taxonomy == 'all' ){
            $('.ajax-filters a').removeClass('active');
          }else{
            $('.ajax-filters a[data-tax="all"]').removeClass('active');
          }
          $(this).toggleClass('active');

          if( $('.ajax-filters a.active').length == 0 ){
            $('.ajax-filters .badge-all').addClass('active');
          }


          $('.ajax-filters a.active').each(function(){
            if( $(this).data('tax') != 'all' ){
              terms_id.push($(this).data('tax'));
            }
          });
          $('.ajax-container').addClass('loading');

          $.ajax({
              url: ajaxurl,
              type: 'POST',
              dataType: 'JSON',
              data: {action: 'filter_posts', post_type: post_type, terms_id: terms_id }
            })
            .done(function(response) {
              if( response ){
                $('.ajax-container .error').remove();
                $('.ajax-container').removeClass('loading');
                if( response.html != ""){
                  $('.ajax-container .carousel .carousel-inner').empty().append(response.html);
                  $('.carousel-navigation .carousel-indicators').remove();
                  $('.carousel-navigation').prepend(response.html_indicators);
                }else{
                  $('.ajax-container .carousel-inner').empty();
                  $('.ajax-container').removeClass('loading').prepend('<div class="error block-text text-center"><p>Aucun téléchargement trouvé avec ces critères.</p></div>');
                }
              }else{
                $('.ajax-container .carousel-inner').empty();
                $('.ajax-container').removeClass('loading').prepend('<div class="error block-text text-center"><p>Une erreur est survenue lors du chargement. Veuillez réessayer.</p></div>');
              }
            })
            .fail(function() {
              $('.ajax-container').removeClass('loading').empty().prepend('<div class="error block-text"><p>Une erreur est survenue lors du chargement. Veuillez réessayer.</p></div>');
            })
            .always(function() {

            });

        });


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        $('.bloc-oura .plus-btn').on('click', function(e){
          e.preventDefault();
          $('.bloc-oura .widget').addClass('active');
        });

        $('.bloc-oura .close-widget').on('click', function(e){
          e.preventDefault();
          $('.bloc-oura .widget').removeClass('active');
        });


        /* Carousel */
        $('#carouselHome').carousel({
          interval: 5000,
          keyboard: true
        });

        $('#carouselHome').on('slid.bs.carousel', function ( event ) {
          var slideTo = parseInt( $(event.relatedTarget).index() + 1);
          $('.list-actualites .counter .current').text(slideTo);
        });

        $('.carousel .carousel-item').each(function(){
          var next = $(this).next();
          if (!next.length) {
            next = $(this).siblings(':first');
          }
          next.children(':first-child').clone().appendTo($(this));

          if (next.next().length>0) {
            next.next().children(':first-child').clone().appendTo($(this));
          }
          else {
            $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
          }
        });

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'page_template_template_titre_de_transport': {
      init: function() {
        $('.dropzone-label, #dropzoneTest').hide();

        $('.block-radios .radio-input').on('change', function(){
          $('.description-radios > div').slideUp();
          $('.description-radios').find('.'+$(this).find('label').attr('for')).slideToggle();

          var nb_pj = $(this).find('input[type="radio"]').attr('data-pj');

          if( nb_pj == 0 ){
            $('.dropzone .files .default-blocks').empty();
            $('.dropzone-label, #dropzoneTest').hide();
          }

          if( nb_pj == 1 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }

          if( nb_pj == 2 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div><div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }

          if( nb_pj == 3 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div><div class="dz-image"></div><div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }

        });

        $('#modalSuccess').modal();

        if( $('.form-container .block-radios input:checked').length != 0 ){
          $('.form-container .submit button').removeAttr('disabled');
          $('.dropzone-label, #dropzoneTest').show();

          var nb_pj = $('.form-container .block-radios input:checked').attr('data-pj');

          if( nb_pj == 0 ){
            $('.dropzone .files .default-blocks').empty();
            $('.dropzone-label, #dropzoneTest').hide();
          }

          if( nb_pj == 1 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }

          if( nb_pj == 2 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div><div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }

          if( nb_pj == 3 ){
            $('.dropzone .files .default-blocks').empty().append('<div class="dz-image"></div><div class="dz-image"></div><div class="dz-image"></div>');
            $('.dropzone-label, #dropzoneTest').show();
          }
        }

        if( $('.form-co .form-errors').length > 0 ){
          $('html, body').animate({scrollTop: $('.form-co').offset().top-$('.form-errors').height()-60}, 500);
        }


        $('.form-row-parrainage').on('change', function(){
          var value = $(this).find('input:checked').val();
          if( value === 'Oui' ){
            $('.parrainage-fields').show();
            $('.parrainage-fields input').attr('required', true);
          }else{
            $('.parrainage-fields').hide();
            $('.parrainage-fields input').attr('required', false);
          }
        });

        $(window).on('load', function(){
          $('.form-row-parrainage input').trigger('change');
        });

      },
      finalize: function() {

        Dropzone.autoDiscover = false;
        if( $('.dropzone').length > 0 ){
          var myDropzone = new Dropzone('#dropzoneTest', {
            paramName: "file", // The name that will be used to transfer the file
            parallelUploads: 1,
            maxFiles: 3,
            url: ajaxUrl,
            maxFilesize: 5, // MB,
            addRemoveLinks: true,
            previewsContainer: '.files',
            acceptedFiles: "image/*, application/pdf",
            thumbnailWidth: null,
            thumbnailHeight: null,
            uploadMultiple: false,
            clickable: '.files',
            dictDefaultMessage: "",
            dictFallbackMessage: "Votre navigateur ne supporte pas cette fonctionnalité.",
            dictInvalidFileType: "Le format d'image est invalide.",
            dictFileTooBig: "Le poids de l'image est trop élevé (max. 3mo)",
            dictCancelUpload: "",
            dictCancelUploadConfirmation: "Le chargement a bien été annulé.",
            dictRemoveFile: "",
            dictMaxFilesExceeded: "Vous ne pouvez ajouter que 3 images",
            init: function() {
              var myDropzone = this;
              myDropzone.on("sending", function(file, xhr, formData) {

              });

              if( $('#dropzone-form .form-errors').length > 0){
                var mockFile1 = { name: $('.uploaded-img-0').data('name'), size: 12345, type: $('.uploaded-img-0').data('type') };
                var mockFile2 = { name: $('.uploaded-img-1').data('name'), size: 12345, type: $('.uploaded-img-1').data('type') };
                var mockFile3 = { name: $('.uploaded-img-2').data('name'), size: 12345, type: $('.uploaded-img-2').data('type') };

                var url_image_1 = $('.uploaded-img-0').attr('data-image');
                var url_image_2 = $('.uploaded-img-1').attr('data-image');
                var url_image_3 = $('.uploaded-img-2').attr('data-image');

                if( url_image_1 ){
                  this.options.addedfile.call(this, mockFile1);
                  this.options.thumbnail.call(this, mockFile1, url_image_1);
                  mockFile1.previewElement.classList.add('dz-success');
                  mockFile1.previewElement.classList.add('dz-complete');
                }
                if( url_image_2 ){
                  this.options.addedfile.call(this, mockFile2);
                  this.options.thumbnail.call(this, mockFile2, url_image_2);
                  mockFile2.previewElement.classList.add('dz-success');
                  mockFile2.previewElement.classList.add('dz-complete');
                }
                if( url_image_3 ){
                  this.options.addedfile.call(this, mockFile3);
                  this.options.thumbnail.call(this, mockFile3, url_image_3);
                  mockFile3.previewElement.classList.add('dz-success');
                  mockFile3.previewElement.classList.add('dz-complete');
                }
              }

              this.on("success", function(file, response) {
                image = JSON.parse(response);
                $('#dropzone-form .submit').prepend('<input type="hidden" name="photos[]" value="'+image.file+'">');
                $('#dropzone-form .submit').prepend('<input type="hidden" name="photos_url[]" value="'+image.url+'">');
                $('#dropzone-form button').attr('disabled',false);
              });
              this.on('complete', function(file) {
                //console.log(file);
              });
              this.on("error", function(file, response) {
                $('#dropzone-form button').attr('disabled',false);
              });
            }

          });
        }
        $('.block-radios').on('change', function(){
          var selected = $(this).find('input:checked');
          if( selected.val() == 'Tout public' ){
            $('#dropzone-form .submit .btn-primary').attr('disabled', false);
          }else{
            $('#dropzone-form .submit .btn-primary').attr('disabled', true);
            if( $('.dropzone .files .dz-preview').length == 0 ){
              $('#dropzone-form .submit .btn-primary').attr('disabled', true);
            }else{
              $('#dropzone-form .submit .btn-primary').attr('disabled', false);
            }
          }

        });
      }
    },
    'page_template_template_contact': {
      init: function() {
        if( $('.form-co .form-errors').length > 0 ){
          $('html, body').animate({scrollTop: $('.form-co').offset().top-$('.form-errors').height()-60}, 500);
        }

        $('#modalSuccess').modal();

      },
      finalize: function() {
        Dropzone.autoDiscover = false;
        if( $('.dropzone').length > 0 ){
          var myDropzone = new Dropzone('#dropzoneTest', {
            paramName: "file", // The name that will be used to transfer the file
            parallelUploads: 1,
            maxFiles: 3,
            url: ajaxUrl,
            maxFilesize: 5, // MB,
            addRemoveLinks: true,
            previewsContainer: '.files',
            acceptedFiles: "image/*, application/pdf",
            thumbnailWidth: null,
            thumbnailHeight: null,
            uploadMultiple: false,
            clickable: '.files',
            dictDefaultMessage: "",
            dictFallbackMessage: "Votre navigateur ne supporte pas cette fonctionnalité.",
            dictInvalidFileType: "Le format d'image est invalide.",
            dictFileTooBig: "Le poids de l'image est trop élevé (max. 3mo)",
            dictCancelUpload: "",
            dictCancelUploadConfirmation: "Le chargement a bien été annulé.",
            dictRemoveFile: "",
            dictMaxFilesExceeded: "Vous ne pouvez ajouter que 3 images",
            init: function() {
              var myDropzone = this;
              myDropzone.on("sending", function(file, xhr, formData) {

              });

              if( $('#dropzone-form .form-errors').length > 0){
                var mockFile1 = { name: $('.uploaded-img-0').data('name'), size: 12345, type: $('.uploaded-img-0').data('type') };
                var mockFile2 = { name: $('.uploaded-img-1').data('name'), size: 12345, type: $('.uploaded-img-1').data('type') };
                var mockFile3 = { name: $('.uploaded-img-2').data('name'), size: 12345, type: $('.uploaded-img-2').data('type') };

                var url_image_1 = $('.uploaded-img-0').attr('data-image');
                var url_image_2 = $('.uploaded-img-1').attr('data-image');
                var url_image_3 = $('.uploaded-img-2').attr('data-image');

                if( url_image_1 ){
                  this.options.addedfile.call(this, mockFile1);
                  this.options.thumbnail.call(this, mockFile1, url_image_1);
                  mockFile1.previewElement.classList.add('dz-success');
                  mockFile1.previewElement.classList.add('dz-complete');
                }
                if( url_image_2 ){
                  this.options.addedfile.call(this, mockFile2);
                  this.options.thumbnail.call(this, mockFile2, url_image_2);
                  mockFile2.previewElement.classList.add('dz-success');
                  mockFile2.previewElement.classList.add('dz-complete');
                }
                if( url_image_3 ){
                  this.options.addedfile.call(this, mockFile3);
                  this.options.thumbnail.call(this, mockFile3, url_image_3);
                  mockFile3.previewElement.classList.add('dz-success');
                  mockFile3.previewElement.classList.add('dz-complete');
                }
              }

              this.on("success", function(file, response) {
                image = JSON.parse(response);
                $('#dropzone-form .submit').prepend('<input type="hidden" name="photos[]" value="'+image.file+'">');
                $('#dropzone-form .submit').prepend('<input type="hidden" name="photos_url[]" value="'+image.url+'">');
                $('#dropzone-form button').attr('disabled',false);
              });
              this.on('complete', function(file) {
                //console.log(file);
              });
              this.on("error", function(file, response) {
                $('#dropzone-form button').attr('disabled',false);
              });
            }

          });
        }
      }
    },
    'page_template_default': {
      init: function() {
        $contentCarousel = $('.carousel-content');

        if( $contentCarousel.length ){
          $contentCarousel.on('slid.bs.carousel', function ( event ) {
            var slideTo = parseInt( $(event.relatedTarget).index() + 1);
            $(this).parents('.carousel-container').find('.counter .current').text(slideTo);
          });
        }
      }
    },
    'page_template_template_telechargements': {
      init: function() {



      }
    },
    'page_template_template_prochain_bus': {
      init: function() {
        $('.reverse-btn').on('click', function(e){
          e.preventDefault();

          if( $(this).attr('href') == '#current' ){
            $(this).parents('.block-arret').find('.current').addClass('collapse');
            $(this).parents('.block-arret').find('.inverse').removeClass('collapse');

          }else{
            $(this).parents('.block-arret').find('.inverse').addClass('collapse');
            $(this).parents('.block-arret').find('.current').removeClass('collapse');
          }

        });
      }
    },
    'page_template_template_cartographie': {
      init: function() {


      },

      finalize: function(){
        //Create new map
        function new_map( $el ) {
          // var
          var $markers = $el.find('.marker');

          // vars
          var styles = [
            {
              "featureType": "administrative",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": "-100"
                }
              ]
            },
            {
              "featureType": "administrative.province",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "landscape",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": -100
                },
                {
                  "lightness": 65
                },
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": -100
                },
                {
                  "lightness": "50"
                },
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.attraction",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.attraction",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "poi.business",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": "-100"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "all",
              "stylers": [
                {
                  "visibility": "simplified"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.highway.controlled_access",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "all",
              "stylers": [
                {
                  "lightness": "30"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "all",
              "stylers": [
                {
                  "lightness": "40"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text",
              "stylers": [
                {
                  "visibility": "on"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "all",
              "stylers": [
                {
                  "saturation": -100
                },
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "hue": "#ffff00"
                },
                {
                  "lightness": -25
                },
                {
                  "saturation": -97
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "lightness": "46"
                },
                {
                  "hue": "#00fff8"
                },
                {
                  "saturation": "6"
                },
                {
                  "gamma": "1.09"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels",
              "stylers": [
                {
                  "lightness": -25
                },
                {
                  "saturation": -100
                }
              ]
            }
          ];

          var args = {
            zoom        : 14,
            center      : new google.maps.LatLng(0, 0),
            mapTypeId   : 'Styled',
            scrollwheel: false,
            mapTypeControl: false,
            fullscreenControl: 0,
            draggable: true
          };
          // create map
          var map = new google.maps.Map( $el[0], args);
          var styledMapType = new google.maps.StyledMapType(styles, { name: 'Styled' });
          map.mapTypes.set('Styled', styledMapType);
          // add a markers reference
          map.markers = [];
          // add markers
          $markers.each(function(){
            add_marker( $(this), map );
          });

          $('.map-inner .badge-co').on('click', function (){
            var filter = $(this).attr('data-type');
            $(this).toggleClass('active');

            if( $(this).hasClass('active') ){
              map.markers.forEach(function(element) {
                if(element.category == filter) {
                  element.setVisible(true);
                }
              });
            }else{
              map.markers.forEach(function(element) {
                if(element.category == filter) {
                  element.setVisible(false);
                }
              });
            }
          });


          // center map
          center_map( map );
          // return
          return map;
        }

        //Add marker
        var infowindows = [];

        function add_marker( $marker, map ) {
          // var
          var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

          var markerIcon = new google.maps.MarkerImage($marker.attr('data-icon'), null, null, null, new google.maps.Size(parseInt($marker.attr('data-width')),parseInt($marker.attr('data-height'))));
          // create marker
          var marker = new google.maps.Marker({
            position    : latlng,
            map         : map,
            category    : $marker.attr('data-type'),
            icon        : markerIcon
          });
          // Règle spécifique pour éviter un bug sur certaines version de l'API
          //if (window.devicePixelRatio > 1.5) {
          //  marker.setOptions({ optimized: false });
          //}
          // add to array
          map.markers.push( marker );
          // if marker contains HTML, add it to an infoWindow
          if( $marker.html() ){
            // create info window
            var infowindow = new google.maps.InfoWindow({
              content     : $marker.html()
            });
            infowindows.push(infowindow);
            // show info window when marker is clicked
            google.maps.event.addListener(marker, 'click', function() {
              for (var i = 0; i < infowindows.length; i++) {
                infowindows[i].close();
              }
              infowindow.open( map, marker );
            });
          }
        }

        //Auto center map and show all markers
        function center_map( map ) {
          // vars
          var bounds = new google.maps.LatLngBounds();
          // loop through all markers and create bounds
          $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
          });
          // only 1 marker?
          if( map.markers.length == 1 ){
            // set center of map
            map.setCenter( bounds.getCenter() );
            map.setZoom( 16 );
          }
          else{
            // fit to bounds
            map.setCenter( bounds.getCenter() );
            map.setZoom( 14 );
            map.fitBounds( bounds );

          }
        }

        //Init map
        var map = null;
        $('#map').each(function(){
          // create map
          map = new_map( $(this) );
        });

        //function initialize() {
        //
        //}
        //
        //google.maps.event.addDomListener(window, "load", initialize);

        //$(document).ready(function(){
        //  $('.map').each(function(){
        //    // create map
        //    map = new_map( $(this) );
        //  });
        //});
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
